import { CompanySizeStepInfo } from '@/components/Steps/CompanySizeStep';
import { PhoneNumberStepInfo } from '@/components/Steps/PhoneNumberStep';
import { TeamInfoStepInfo } from '@/components/Steps/TeamInfoStep';

import { DefaultStepsInfo, GoogleAuthStepsInfo } from '../../types';

import { FocusAreaStepInfo } from './FocusAreaStep';
import { InviteTeamStepInfo } from './InviteTeamStep';
import { TrackingModeStepInfo } from './TrackingModeStep';

export const defaultFlowSteps = (): DefaultStepsInfo[] => [
  FocusAreaStepInfo,
  TeamInfoStepInfo,
  TrackingModeStepInfo,
  InviteTeamStepInfo,
];

export const ssoFlowSteps = (): GoogleAuthStepsInfo[] => [
  CompanySizeStepInfo,
  PhoneNumberStepInfo,
  FocusAreaStepInfo,
  TeamInfoStepInfo,
  TrackingModeStepInfo,
  InviteTeamStepInfo,
];

export * from './CompanySizeStep';
export * from './DownloadAppsStep';
export * from './FocusAreaStep';
export * from './InviteLinkShareStep';
export * from './InviteTeamStep';
export * from './PhoneNumberStep';
export * from './TeamInfoStep';
export * from './TrackingModeStep';

